import { Injectable } from '@angular/core';
import { Assurance } from '../model/assurance';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';

@Injectable({
    providedIn: 'root'
  })
  export class AssuranceService{
  
  constructor(private _restClientService : RestClientService) 
  {}
  
  getAllAssurances() 
  {
    return this._restClientService.load<Assurance[]>('assurance/assurances');
  }
  
  add(assurance) {
    return  this._restClientService.save<Assurance>('assurance/add-assurance', assurance);
  }
  
  update(assurance) {
    return  this._restClientService.put<Assurance>(`assurance/update-assurance`, assurance);
  }
  
  getAssuranceById(assuranceId)
  {
    return this._restClientService.load<Assurance>('assurance/assurance-by-id/'+assuranceId);
  }

  getAssurancesByAmount(typeCredit,amount) 
  {
    return this._restClientService.load<Assurance[]>('assurance/assurances-by-amount?amount='+amount+"&typecredit="+typeCredit);
  }
  
  
}      

    